import { cva } from 'class-variance-authority';

export const flag = cva('text-color-text-light absolute font-bold', {
  variants: {
    size: {
      large: 'text-size-h2 ml-0.5',
      normal: 'text-size-h3 ml-[0.15rem]',
      small: 'text-size-h5 ml-[0.2rem]',
    },
  },
  defaultVariants: { size: 'normal' },
});
